<template>
  <IonMenu
    :menu-id="menuId"
    :content-id="contentId"
    :side="menuSide"
    :swipe-gesture="false"
    @ionDidOpen="toggleSwipeGesture(true)"
    @ionDidClose="onClose()"
  >
    <IonContent>
      <slot name="menuContent"></slot>
    </IonContent>
  </IonMenu>
</template>

<script lang="ts">
import { IonContent, IonMenu, menuController } from "@ionic/vue";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "CustomIonMenu",
  components: { IonMenu, IonContent },
  props: {
    menuId: { type: String as PropType<string>, required: true },
    contentId: { type: String as PropType<string>, default: "main-content" },
    menuSide: { type: String as PropType<"start" | "end">, default: "start" },
  },
  emits: ["onClose"],
  setup(props, { emit }) {
    function toggleSwipeGesture(enable: boolean) {
      menuController.get(props.menuId).then((menu) => {
        if (menu) {
          menu.swipeGesture = enable;
        }
      });
    }
    function onClose() {
      toggleSwipeGesture(false);
      emit("onClose");
    }
    return { toggleSwipeGesture, onClose };
  },
});
</script>
